import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import InsumoRecord from '@components/InsumoRecord/InsumoRecord';
import formatMessage from './i18n/formatMessage';
import Insumo from '@resources/InsumosEnum';

/**
 * Componente para tela de Inseticidas
 *
 * @author Gabriela Farias <gabriela.farias@kepha.com.br>
 * @param {*} props
 * @returns {JSX.Element}
 */
function Inseticidas(props) {
  useEffect(() => {
    const title = 'inseticida.inseticida';
    if (props.itensState.name !== title) {
      props.dispatch({ type: 'UPDATE_TOOLBAR', toolbar: formatMessage(title), name: title });
    }
  }, []);

  return (
    <InsumoRecord
      chipData={props.chipData}
      infoUsuario={props.infoUsuario}
      insumoEnum={Insumo.INSETICIDA}
      insumoURL='inseticidas'
      viewKey='inseticidas'
      deleteMessageSucess={formatMessage('inseticida.inseticidaRemovidoComSucesso')}
      mensagemFalhaDeletar={formatMessage('inseticida.falhaAoExcluirInseticida')}
      mensagemDelete={formatMessage('inseticida.desejaExcluir')}
    />
  );
}

const mapStateToProps = state => ({
  itensState: state.toolbar,
  infoUsuario: state.adicionarInfoUsuario.info,
  chipData: state.chips.chipData.filter(date => {
    return date.id === 'inseticidas';
  })[0].content
});

export default connect(mapStateToProps)(Inseticidas);
